/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export enum COMPONENT_TYPE {
  server = 'SERVER',
  edge = 'EDGE',
}

export function validateComponentType(componentType: string | undefined): COMPONENT_TYPE {
  if (componentType === undefined || componentType === 'server') {
    return COMPONENT_TYPE.server;
  }
  return COMPONENT_TYPE.edge;
}
